module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen.3f9525bb.png";